
import { motion } from "framer-motion";

const fadeInAnimationVariants = {
    initial: { opacity: 0, y: 50 },
    animate: (index) => ({
      opacity: 1,
      y: 0,
      transition: { delay: 0.05 * index },
    }),
  };
export default function Whatugetcomponent() {
  return (
    <div className="bg-white text-gray-800 justify-center font-sans px-4 sm:px-6 lg:px-8 mb-6 space-y-6">
      {/* Title Section (unchanged) */}
      <div className="hidden md:block text-center max-w-5xl mx-auto">
        <motion.div
          variants={fadeInAnimationVariants}
        initial="initial"
        whileInView="animate"
        viewport={{ once: true }}
          className="inline-block bg-red-600 text-white font-semibold px-4 py-1 sm:px-12 sm:py-2 rounded text-sm sm:text-xl"
          style={{ fontFamily: "Poppins" }}
        >
          What will you get
        </motion.div>
        {/* <motion.div
          className="mt-4 text-2xl sm:text-3xl md:text-4xl font-bold mb-8 sm:mb-10"
          style={{ fontFamily: "Poppins" }}
          variants={fadeInAnimationVariants}
          initial="initial"
          whileInView="animate"
          viewport={{ once: true }}
        >
          Your Ultimate{" "}
          <span className="text-orange-500" style={{ fontFamily: "Poppins" }}>
            Assessment Companion
          </span>
        </motion.div> */}
      </div>

      <motion.div variants={fadeInAnimationVariants}
          initial="initial"
          whileInView="animate"
          viewport={{ once: true }} className="md:hidden bg-gradient-to-b from-[#FF5E5E] to-[#FF8C8C] rounded-2xl px-6 py-4 text-center">
        <div
          
          className="inline-block border-2 bg-red-700 border-white px-6 py-2 text-white font-semibold text-base mb-4"
          style={{ fontFamily: "Poppins" }}
        >
          What will you get
        </div>
        <h2
          className="text-white text-2xl font-bold"
          style={{ fontFamily: "Poppins" }}
        >
          Your Ultimate Assessment Companion
        </h2>
      </motion.div>
      <motion.div variants={fadeInAnimationVariants}
        initial="initial"
        whileInView="animate"
        viewport={{ once: true }} className="md:hidden flex justify-center w-full order-1 lg:order-none">
        <img
          src='https://dbqa318yoj3nn.cloudfront.net/assessmentgif.gif'
          alt="Assessment Animation"
          className="w-full max-w-sm sm:max-w-md rounded-lg"
        />
      </motion.div>

      {/* Assessment Report Section */}
      <div className="flex flex-col lg:flex-row items-center justify-center max-w-5xl xl:max-w-6xl mx-auto">
        {/* Left: GIF */}
        <motion.div
           initial={{ opacity: 0, x: -100 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 1 }}
              viewport={{ once: true, amount: 0.3 }}
          className="hidden md:flex w-full lg:w-[40%] xl:w-[34%] justify-center order-1 lg:order-none"
        >
          <img
            src='https://dbqa318yoj3nn.cloudfront.net/assessmentgif.gif'
            alt="Assessment Animation"
            className="w-full max-w-sm sm:max-w-md rounded-lg"
          />
        </motion.div>

        {/* Right: Report Info */}
        <motion.div
          initial={{ opacity: 0, x: 100 }}
             whileInView={{ opacity: 1, x: 0 }}
             transition={{ duration: 1 }}
             viewport={{ once: true, amount: 0.3 }}
          className="w-full lg:w-[60%] xl:w-[55%]  p-6 sm:p-8 rounded-2xl shadow-xl md:h-auto lg:h-auto"
          style={{ backgroundColor: "#E5CCFF" }}
        >
          <div
            className="text-purple-800 text-xl sm:text-2xl font-bold mb-6 text-left "
            style={{ fontFamily: "Montserrat" }}
          >
            Detailed Personalized Report
          </div>
          <div className="space-y-4 sm:space-y-5 text-white text-sm sm:text-base leading-relaxed">
            {[
              {
                title: "Instant Results Analysis:",
                text: "Get quick, data-driven insights into your aptitude, personality, emotional intelligence, and career interests for a clear view of your strengths.",
              },
              {
                title: "Clear Career Exploration:",
                text: "Explore multiple career paths tailored to your unique profile based on your aptitude, personality, and interests.",
              },
              {
                title: "Personalized Development Insights:",
                text: "Receive tailored guidance on strengths and improvement areas to support informed academic and career decisions.",
              },
            ].map((item, i) => (
              <div className="flex items-start gap-2" key={i}>
                <span className="flex-shrink-0 mt-1 px-2 py-1 bg-purple-700 rounded-full text-xs font-bold">
                  {i + 1}
                </span>
                <div>
                  <span
                    className="font-bold text-black"
                    style={{ fontFamily: "Poppins" }}
                  >
                    {item.title}
                  </span>{" "}
                  <span
                    className="text-black leading-8 md:leading-6"
                    style={{ fontFamily: "Poppins" }}
                  >
                    {item.text}
                  </span>
                </div>
              </div>
            ))}
          </div>
        </motion.div>
      </div>

      {/* Counselling Session Section */}
      <section
      >
        <motion.div initial={{ opacity: 0, x: -100 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 1 }}
              viewport={{ once: true, amount: 0.3 }} className="text-white p-6 rounded-xl shadow-xl max-w-5xl mx-auto flex flex-col lg:flex-row gap-6 items-start relative md:h-auto lg:h-auto"
        style={{ backgroundColor: "#90B2FF" }}>
          {/* Image side */}
          <div className="w-full lg:w-1/2">
            <img
              src='https://dbqa318yoj3nn.cloudfront.net/counsellingimage.png'
              alt="Counselling"
              className="w-full absolute top-[-35px] left-[-23%] h-auto max-h-[390px] object-contain rounded-lg hidden lg:block"
            />
          </div>

          {/* <img
            src='https://dbqa318yoj3nn.cloudfront.net/counsellingimage.png'// Replace with your image variable or path
            alt="Counselling Session"
            className="absolute bottom-0 w-[35%] sm:bottom-[-10px] right-[10px]
                   sm:w-[40%] md:hidden max-w-xs"
          /> */}

          {/* Text content */}
          <div className="w-full lg:w-1/2">
            <div
              className="text-blue-900 text-xl sm:text-4xl font-bold mb-4"
              style={{ fontFamily: "Montserrat" }}
            >
              Counselling Session
            </div>
            <p
              className="text-sm sm:text-base text-black mb-4"
              style={{ fontFamily: "Poppins" }}
            >
              Our in-house counsellors support students and parents by
              simplifying the SkillSphere Assessment Report into clear,
              easy-to-understand insights about strengths, interests, and areas
              for growth by :
            </p>

            <ul
              className="space-y-4 text-sm sm:text-base"
              style={{ fontFamily: "Poppins" }}
            >
              <li className="flex items-start gap-2">
                <span className="text-yellow-300 text-lg">👉</span>
                <span
                  className="text-black w-[90%]   md:w-full"
                  style={{ fontFamily: "Poppins" }}
                >
                  Providing personalized guidance to support emotional
                  intelligence, cognitive skills, and career exploration.
                </span>
              </li>
              <li className="flex items-start gap-2">
                <span className="text-yellow-300 text-lg">👉</span>
                <span
                  className="text-black w-full md:w-full"
                  style={{ fontFamily: "Poppins" }}
                >
                  Building an actionable plan for academic success and future
                  career paths.
                </span>
              </li>
            </ul>
          </div>
        </motion.div>
      </section>

      {/* Clubs and Expectations */}
      <section className="max-w-5xl mx-auto mt-10 mb-10 grid grid-cols-1 lg:grid-cols-[1.1fr_0.9fr] gap-6">
        {/* Clubs - orange */}
        <motion.div
          initial={{ opacity: 0, x: -100 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 1 }}
              viewport={{ once: true, amount: 0.3 }}
          className="p-6 sm:p-5 rounded-2xl shadow-xl overflow-hidden relative md:h-auto lg:min-h-[300px]"
          style={{ backgroundColor: "#FFE66C" }}
        >
          <div
            className="text-[#4D2C0C] text-xl sm:text-2xl font-bold mb-4 relative z-10"
            style={{ fontFamily: "Montserrat" }}
          >
            Specialized Skill-Building Clubs
          </div>

          <div className="flex flex-col relative">
            <div className=" w-full   lg:w-[49%] relative z-10">
              <p
                className="text-sm sm:text-base leading-relaxed"
                style={{ fontFamily: "Poppins" }}
              >
                Post-counselling, students are recommended one of our
                Specialized Skill-Building Clubs based on their assessment
                results. Each club offers tailored training to develop
                real-world skills in areas like leadership, problem-solving,
                innovation, effective communication and many more.
              </p>
            </div>

            <div className="absolute right-[-10%] bottom-[-20%]  md:w-[70%] max-w-[600px]">
              <img
                src='https://dbqa318yoj3nn.cloudfront.net/clubsimage.png'
                alt="Skill Building Clubs"
                className="w-full h-auto object-contain drop-shadow-xl hidden lg:block"
              />
            </div>
            {/* <img
              src='https://dbqa318yoj3nn.cloudfront.net/clubsimage.png'// Replace with your image variable or path
              alt="Skill Building Clubs"
              className="absolute bottom-[-25px] w-[35%] sm:bottom-[-20px] right-[-20px]
           sm:w-[30%] md:hidden max-w-xs"
            /> */}
          </div>
        </motion.div>

        {/* Expectations - green */}
        <motion.div
         initial={{ opacity: 0, x: 100 }}
             whileInView={{ opacity: 1, x: 0 }}
             transition={{ duration: 1 }}
             viewport={{ once: true, amount: 0.3 }}
          className=" p-6 sm:p-6 rounded-2xl shadow-lg md:h-auto lg:h-[350px] flex flex-col justify-between"
          style={{ backgroundColor: "#8BC822" }}
        >
          <div>
            <div
              className="text-green-900 text-xl sm:text-2xl font-bold mb-2"
              style={{ fontFamily: "Montserrat" }}
            >
              What to Expect:
            </div>
            <ul
              className="list-decimal list-inside text-white text-sm sm:text-base tracking-wide leading-10 space-y-2"
              style={{ fontFamily: "Poppins" }}
            >
              <li className=" leading-8" style={{ fontFamily: "Poppins" }}>
                Club Assignment: Based on your profile, you may join a club that
                aligns with your interests and career goals.
              </li>
              <li className=" leading-8" style={{ fontFamily: "Poppins" }}>
                Training & Development: Participate in hands-on projects and
                simulations to build essential skills.
              </li>
            </ul>
          </div>
        </motion.div>
      </section>
    </div>
  );
}
